export default "__VITE_ASSET__3515331e__"